//import orange from "@mui/material/colors/orange";
//import blue from "@mui/material/colors/blue";
//import green from "@mui/material/colors/green";
import { createTheme, PaletteMode, colors, Palette } from "@mui/material";
import shadows, { Shadows } from "@mui/material/styles/shadows";

shadows[1] = 'rgba(149, 157, 165, 0.2) 0px 8px 24px';
shadows[2] = 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px';
shadows[3] = 'rgba(0, 0, 0, 0.35) 0px 5px 15px'

declare module '@mui/material' {
	export interface ButtonPropsColorOverrides {
		grey: true
	}
}

// extends MUI typings
//declare module "@material-ui/core/styles/createPalette" {
//  interface Palette {
//    success: PaletteColor
//  }
//  interface PaletteOptions {
//    success?: PaletteColorOptions,
//  }
//}

//const customShadows = [...shadows] as Shadows;
//customShadows[1] = "0 9px 14px -5px rgba(0, 0, 0, .10)";
//const SHADOWS = [
//	"",
//	"0 9px 14px -5px rgba(0, 0, 0, .10)"
//] as any;

const COMMON_PALETTE: {
	[k in keyof Palette]?: Palette[k]
} = {
	primary: {
		main: colors.blue[500],
		light: colors.blue[300],
		dark: colors.blue[700],
		contrastText: "#fff"
	},
	secondary: {
		// main: colors.orange[700],
		// light: colors.orange[400],
		// dark: colors.orange[900],
		main: colors.cyan[700],
		light: colors.cyan[400],
		dark: colors.cyan[900],
		contrastText: "#fff"
	},
	text: {
		primary: "#264251",
		disabled: null,
		//main: '#222222',
		secondary: "#959ba4",
	},
	//success: {
	//	//main: "#aed581",
	//	//dark: colors.green["800"],
	//	contrastText: '#fff'	
	//}
};

const LIGHT_PALETTE = {
	background: {
		default: '#f5f5f6',
		paper: '#ffffff',
	},
	text: {
		primary: '#264251',
		secondary: '#959ba4',
	},
	grey: {
		main: colors.grey[600],
	}
};

const DARK_PALETTE = {};
//const a: ComponentsOverrides<Theme>['MuiButton']
const theme = (mode: PaletteMode = 'light') => createTheme({
	components: {
		MuiTypography: {
			styleOverrides: {
				h5: {
					fontWeight: 300
				}
			}
		},
		MuiButton: {
			styleOverrides: {
				root: {
					borderRadius: 4,
					textTransform: 'none'
				},
				sizeSmall: {
					lineHeight: 1.5
				}
			},
			defaultProps: {
				disableElevation: true
			}
		},
		//MuiTextField: {
		//	styleOverrides: {
		//		root: {
		//			borderRadius: 0
		//		},
		//	},
			//defaultProps: {
			//	size: 'small';
			//}
		//},
		//MuiInputBase: {
		//	styleOverrides: {
		//		root: {
		//			//borderRadius: '0 !important',
		//		},
		//	},
		//}
		//MuiCssBaseline: {
		//	'styleOverrides': {
		//		'bod'
		//	}
		//}
	},
	//overrides: {
	//	//MuiCssBaseline: {
	//	//	'@global': {
	//	//		body: {
	//	//			backgroundColor: 'white'
	//	//		}
	//	//	},
	//	//},
		
	//},
	shape: {
		borderRadius: 0
	},
	typography: {
    fontFamily: [
      '"Segoe UI"',
      '-apple-system',
      'BlinkMacSystemFont',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
	shadows,
	palette: {
		mode,
		...COMMON_PALETTE,
		...(mode === 'light' ? LIGHT_PALETTE : DARK_PALETTE),
	},

});

export default theme;
